mode
<template>
  <div class="wrapper">
    <div class="icon-search-container mx-4 w-[42px] h-[42px]" :class="[isSearchActive ? 'active' : '', classList]">
      <div class="flex justify-center items-center w-[42px] h-[42px]" @click="activateSearch">
        <img class="w-[17px]" :src="require('@/assets/icons/svg/' + icon)" alt="Search" />
      </div>
      <input v-model="searchInput" id="test-input" type="text" class="h-[42px] search-input text-base"
        :class="[isSearchActive ? 'active' : '', placeholderColor]" :placeholder="placeholder"
        @keyup="$emit('search', searchInput)" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  classList: {
    type: String,
    default: "bg-qooWhite-5",
  },
  default: {
    type: String,
    default: "",
  },
  placeholderColor: {
    type: String,
    default: "placeholder-mainBlack-300",
  },
  text: {
    type: String,
  },
  icon: {
    type: String,
    default: "floorplans/search.svg",
  },
  placeholder: {
    type: String,
    default: "Search by location",
  },
});
const isSearchActive = ref(false);
const searchInput = ref("");
const emit = defineEmits(["activateSearch", 'search']);

const activateSearch = () => {
  isSearchActive.value = !isSearchActive.value;
  emit("activateSearch", isSearchActive.value);
};
onMounted(() => {
  if (props.text) {
    // console.log('onMounted text');
    isSearchActive.value = false;
    activateSearch()
    searchInput.value = props.text;
    emit('search', searchInput.value)
  }

  if (props.default) {
    setTimeout(() => {
      searchInput.value = props.default;
      isSearchActive.value = true;
    }, 500);
  }
});

watch(
  () => props.text,
  () => {
    // console.log('watch text');

    if (props.text != searchInput.value) {
      isSearchActive.value = false;
      activateSearch()
      searchInput.value = props.text;
      emit('search', searchInput.value)
    }
  },
);

watch(
  () => props.default,
  () => {
    // console.log('watch text');

    if (props.default) {
      setTimeout(() => {
        searchInput.value = props.default;
        isSearchActive.value = true;
      }, 500);
    }
  },
);
</script>

<style lang="scss" scoped>
.icon-search-container {
  display: inline-block;
  border-radius: 50px;
  position: relative;
  transition: width 0.8s ease-out;
  backface-visibility: hidden;
}

.icon-search-container.active {
  width: 300px;
}

@media screen and (max-width: 768px) {
  .icon-search-container.active {
    width: 230px;
  }
  .icon-search-container.active .search-input {
    width: 190px;
  }
}

.icon-search-container.active .fa-times-circle {
  opacity: 1;
}

.icon-search-container.active .search-input {
  width: 250px;
}

.fa-search {
  color: #2980b9;
  font-size: 30px;
  position: absolute;
  top: 7px;
  left: 8px;
  cursor: pointer;
}

.fa-times-circle {
  opacity: 0;
  color: #d9d9d9;
  font-size: 20px;
  position: absolute;
  top: 12px;
  right: 8px;
  transition: opacity 0.8s ease-out;
  cursor: pointer;
}

.search-input {
  position: absolute;
  cursor: default;
  left: 40px;
  top: 0px;
  width: 0;
  padding: 5px;
  border: none;
  outline: none;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 0);
  transition: width 0.7s ease-out;
  /* transition-delay: 0.3s; */
  transition-delay: unset !important;

  &::placeholder {
    font-size: 14px;
  }

  @media screen and (max-width: 768px) {
    &::placeholder {
      font-size: 12px;
    }
  }
}

.search-input.active {
  /* transition-delay: unset !important; */
  transition-delay: 0.3s;
}
</style>
